import { ChangePasswordParams } from 'interfaces/auth';
import { getValidToken } from 'utils/auth';
import { authClient } from './apiClients';

// authClient는 JWT 인터셉터를 안 타(자동 갱신 없음) 만료 임박이면 갱신된 토큰을 직접 확보해 주입
const authHeader = async () => {
  const token = await getValidToken();
  return token ? { Authorization: `Bearer ${token}` } : undefined;
};

export const changeVendysPassword = async (params: ChangePasswordParams): Promise<void> => {
  const headers = await authHeader();
  if (!headers) return;
  await authClient.put('/vendys/v1/password', params, { headers });
};

export const skipChangeVendysPassword = async (): Promise<void> => {
  const headers = await authHeader();
  if (!headers) return;
  await authClient.put('/vendys/v1/password/ignore', null, { headers });
};
